var _path, _path2, _path3, _linearGradient, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c94f60",
    d: "M42.583,9.067l-3.651-3.65c-0.555-0.556-1.459-0.556-2.015,0l-1.718,1.72l5.664,5.664l1.72-1.718 C43.139,10.526,43.139,9.625,42.583,9.067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M6.905,35.43L5,43l7.571-1.906l0.794-6.567L6.905,35.43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M36.032,17.632l-23.46,23.461l-5.665-5.665l23.46-23.461L36.032,17.632z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "YoPixpDbHWOyk~b005eF1a",
    x1: 35.612,
    x2: 35.612,
    y1: 7.494,
    y2: 17.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#YoPixpDbHWOyk~b005eF1a)",
    d: "M30.363,11.968l4.832-4.834l5.668,5.664l-4.832,4.834L30.363,11.968z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M5.965,39.172L5,43l3.827-0.965L5.965,39.172z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.afa685758e174c09117f7a315b359202.svg";
export { ForwardRef as ReactComponent };